import { useLayoutEffect as e, useEffect as f } from "react";
let t = typeof window != "undefined" ? e : f;
export { t as useIsoMorphicEffect };